import React, { useState, useEffect, useMemo } from 'react'
import {
  Table,
  Form,
  Pagination,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Row,
  Col,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FaEdit, FaSyncAlt, FaUser } from 'react-icons/fa'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import axios from 'axios'
import EditAssignClass from './EditAssignClass'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthContext'

const AssignClass = () => {
  const {token} =useAuth();
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const navigate = useNavigate()

  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedClass, setSelectedClass] = useState(null)
  // const [assignedClasses, setAssignedClasses] = useState([])
  const [studentCount, setStudentCount] = useState(null)
  const [countColor, setCountColor] = useState('') // Add color for the response
  const [selectedNewCourse, setSelectedNewCourse] = useState([])
  const [courses, setCourses] = useState([])
  const [isAcknowledged, setIsAcknowledged] = useState(false)

  const [classes, setClasses] = useState([])
  const [teachers, setTeachers] = useState([])
  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])
  useEffect(() => {
    const userLogged = Cookies.get('user')
    const userRoleLogged = Cookies.get('role')
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
    if (userRoleLogged) {
      try {
        setUserRole(JSON.parse(userRoleLogged))
        console.log('User:', JSON.parse(userRoleLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
        if (user.user_type === 'teacher') return
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }
    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/class/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        setClasses(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])

  useEffect(() => {
    const userCookie = Cookies.get('user')
    const instituteId = Cookies.get('institute_id')

    console.log('Raw user cookie:', userCookie)
    let token = null

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
        console.log('My user is :', user.user_type)
        if (user.user_type === 'teacher') return
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(instituteId),
        }

        const response = await axios.get(
          BASE_URL+'/teacher/all',
          { headers },
        )

        console.log('Teachers response:', response.data.data)
        setTeachers(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])

  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    // const userCookie = Cookies.get('user')
    // const teacher_id = teachers.id
    let teacherToken = null
    let adminToken = null

    // If user is a teacher, fetch their classes
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        teacherToken = user.token
        if (user.user_type === 'teacher') {
          teacherToken = user.token
          const teacher_id = user.teacher_id
          console.log('TEACHER - ID : ', teacher_id)
          axios
            .get(BASE_URL+`/teacher-classes`, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${teacherToken}`,
              },
            })
            .then((res) => {
              console.log('Teacher class response:', res.data.data)
              const teacherClassData = res.data.data
              console.log('teacherClassData', teacherClassData.teacher_name)
              setData(teacherClassData)
            })
            .catch((err) => {
              console.error('Teacher API error:', err.response?.data?.message)
            })
        }
        // If admin, fetch all assigned classes
        else {
          try {
            const user = JSON.parse(userCookie)
            adminToken = user.token

            axios
              .get(
                BASE_URL+'/get/all/assigned/classes',
                {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${adminToken}`,
                    institute_id: Number(instituteId),
                  },
                },
              )
              .then((res) => {
                console.log('Assigned class response:', res.data.data)
                setData(res.data.data)
              })
              .catch((err) => {
                toast.error(
                  err.response?.data?.message || 'Something went wrong',
                )
              })
          } catch (err) {
            console.error('Parse admin cookie failed', err)
          }
        }
      } catch (err) {
        console.error('Parse user cookie failed', err)
      }
    }
  }, [loading])

  useEffect(() => {
    fetchAssignedClasses()
  }, [])

  const [newAssignedTeacher, setNewAssignedTeacher] = useState([])

  const filteredData = useMemo(() => {
    if (!Array.isArray(data)) return []
    return data.filter((item) =>
      Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search.trim().toLowerCase()),
      ),
    )
  }, [data, search])

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewAssignedTeacher((prev) => ({ ...prev, [name]: value }))
    console.log('name', name, 'value', value)
  }

  // Add New Teacher
  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const headers = {
        Authorization: `Bearer ${user.token}`,
      }
      const payload = {
        ...newAssignedTeacher,
        headers,
      }
      console.log('Sending data: ', newAssignedTeacher)
      const response = await ApiEndpoints.addAssignClass(payload)
      console.log('Response during post', response)
      setNewAssignedTeacher('Response: ', response)
      // setData(response.data)
      // Reset the form after submission
      setNewAssignedTeacher({
        teacher_id: '',
        class_id: '',
      })

      toast.success(response.data.result)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.data?.result)
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const [courseTouched, setCourseTouched] = useState(false)

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    setNewAssignedTeacher((prev) => ({ ...prev, course_id: courseId }))

    console.log('Selected course Id:', courseId)
    setCourseTouched(true)
    setSelectedNewCourse(courseId)
    setStudentCount(null)
    console.log('Cleared Classes')

    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            // toast.error('No classes found for this course.')
            setClasses([])
            setStudentCount(null)
          } else {
            setClasses(data.data)
            // setUpdatedStudent(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            // toast.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            // toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    setNewAssignedTeacher((prev) => ({ ...prev, class_id: classId }))

    // Clear previous student count
    setStudentCount(null)
    setCountColor('')

    if (classId) {
      // Call the API to get the student count for the selected class
      fetch(
        BASE_URL+`/get/class/student/count?class_id=${classId}`,{
        headers :
          {
          Authorization: `Bearer ${token}`
        }
      } 
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data?.status &&
            data?.data?.current !== undefined &&
            data?.data?.maximum_limit !== undefined
          ) {
            const current = data.data.current === null ? 0 : data.data.current // Treat null as 0
            const maximum_limit = parseInt(data.data.maximum_limit, 10) // Parse maximum_limit as a number
            setStudentCount({ current, maximum_limit }) // Set the state with correct property names
            setCountColor('green') // Example color for success
          } else {
            setStudentCount('No data available')
            setCountColor('red') // Example color for no data
          }
        })
        .catch((error) => {
          console.error('Error fetching student count:', error)
          setStudentCount('Error fetching data')
          setCountColor('red') // Example color for error
        })
    }
  }
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  const handleRefresh = async () => {
    setSearch({})

    setData(data)
    setSearch('')
    setCurrentPage(1)
  }
  const fetchAssignedClasses = async () => {
    const instituteId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token

        if (user.user_type === 'teacher') {
          const res = await axios.get(
            BASE_URL+`/teacher-classes`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            },
          )
          const teacherClassData = res.data.data
          // const assigned = teacherClassData?.assigned_classes || []
          // setData(assigned)
          setData(teacherClassData)
        } else {
          const res = await axios.get(
            BASE_URL+'/get/all/assigned/classes',
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                institute_id: Number(instituteId),
              },
            },
          )
          setData(res.data.data)
        }
      } catch (error) {
        console.error('Error fetching assigned classes:', error)
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }
  }
  const handleNavigateToCreateClass = () => {
    navigate('/AddClass')
  }
  return (
    <>
      <style>
        {`
          .blinking-link {
            color: blue;
            text-decoration: none;
            cursor: pointer;
            animation: blink 1s infinite;
            font-weight:bold;
          }

          @keyframes blink {
            0% { color: blue; }
            50% { color: red; }
            100% { color: blue; }
          }
          @media (max-width: 767.98px) {
          .responsive-btn {
            margin-top:5px !important;
            padding: 0.25rem 0.5rem !important;
            font-size: 0.875rem !important; /* equivalent to btn-sm */
          }
      `}
      </style>
      <div style={{ marginLeft }}>
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 768 ? '55px' : '-12px',
          }}
        >
          <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
            <h2 className="m-0">Assigned Classes</h2>
            {user?.user_type !== 'teacher' && (
              <Button
                variant="light"
                className="fw-bold px-4 py-2 rounded shadow-sm d-flex align-items-center responsive-btn"
                onClick={() => setShowModal(true)}
              >
                <FaUser size={18} className="me-2" />
                Add New Assign
              </Button>
              )}
          </div>
        {user?.user_type !== 'teacher' && (
          <Row className="g-2 align-items-center justify-content-between mt-4">
            <Col xs={12} md={3}>
              <Form.Control
                type="text"
                placeholder="Search Teacher Name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Col>
            <Col xs="auto">
              <Button
                variant="outline-primary"
                onClick={handleRefresh}
                title="Refresh"
                className="w-auto"
              >
                <FaSyncAlt /> Refresh
              </Button>
            </Col>
          </Row>
          )}

        {user?.user_type !== 'teacher' && (
          <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
            <p className="text-black m-0">
              Total Records: {filteredData.length}
            </p>

            <Form.Select
              className="w-auto"
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(parseInt(e.target.value))
                setCurrentPage(1)
              }}
            >
              <option value="10">10 per page</option>
              <option value="20">20 per page</option>
              <option value="30">30 per page</option>
            </Form.Select>
          </div>
          )}

        {user?.user_type == 'teacher' && (
          <div className="mb-5"></div>
        )}
        </div>
        {/* Teacher Table */}
        <Table
          striped
          bordered
          hover
          responsive
          className="rounded overflow-hidden shadow-sm"
        >
          <thead className="bg-dark text-white">
            <tr>
              <th>Teacher Name</th>
              <th>Assigned Class</th>
              {user?.user_type !== 'teacher' && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {(() => {
              console.log('Current Items:', currentItems)
              console.log('User Type:', user?.user_type)
              console.log('Full data:', data)

              if (user?.user_type === 'teacher') {
                const assignedClasses = data?.assigned_classes || []

                if (assignedClasses.length === 0) {
                  return (
                    <tr className="align-middle">
                      <td>{data?.teacher_name || 'Unknown Teacher'}</td>
                      <td>No Assigned Classes</td>
                    </tr>
                  )
                }

                return assignedClasses.map((cls) => (
                  <tr key={cls.id} className="align-middle">
                    <td>{data.teacher_name}</td>
                    <td>{cls.class_name}</td>
                  </tr>
                ))
              }

              // Non-teacher users (e.g., admin)
              if (currentItems.length === 0) {
                return (
                  <tr>
                    <td
                      colSpan="3"
                      className="text-center text-muted fw-bold p-4"
                    >
                      No records found
                    </td>
                  </tr>
                )
              }

              return currentItems
                .filter((item) => item.teacher_name !== 'Unknown Teacher')
                .flatMap((item, index) => {
                  const assignedClasses = item.assigned_classes || []

                  if (assignedClasses.length === 0) {
                    return (
                      <tr key={`${index}-no-classes`} className="align-middle">
                        <td>{item.teacher_name}</td>
                        <td>No Assigned Classes</td>
                        <td className="text-center">
                          <div className="d-flex flex-wrap justify-content-center gap-2">
                            <Button
                              variant="warning"
                              onClick={() => {
                                setSelectedClass({
                                  teacher_id: item.teacher_id,
                                  id: null,
                                  class_id: null,
                                })
                                setShowEditModal(true)
                              }}
                            >
                              <FaEdit />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    )
                  }

                  return assignedClasses.map((cls) => (
                    <tr
                      key={`${item.teacher_id}-${cls.id}`}
                      className="align-middle"
                    >
                      <td>{item.teacher_name}</td>
                      <td>{cls.class_name}</td>
                      <td className="text-center">
                        <div className="d-flex flex-wrap justify-content-center gap-2">
                          <Button
                            variant="warning"
                            onClick={() => {
                              setSelectedClass({
                                teacher_id: item.teacher_id,
                                id: cls.id,
                                class_id: cls.class_id,
                              })
                              setShowEditModal(true)
                            }}
                          >
                            <FaEdit />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                })
            })()}
          </tbody>
        </Table>

        {/* Pagination & Total Records */}
        <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
          <Pagination>
            <Pagination.Prev
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            />
            {[...Array(totalPages)].map((_, i) => (
              <Pagination.Item
                key={i}
                active={i + 1 === currentPage}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </div>

        <Modal
          size="lg"
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
        >
          <Modal.Header closeButton className="bg-secondary text-white">
            <Modal.Title>Add New Assign</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSave}>
              {/* <Form.Group className="mb-3">
              <Form.Label>Class</Form.Label>
              <Form.Select
                name="class_id"
                value={newAssignedTeacher.class_id}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Class</option>
                {classes.map((clas) => (
                  <option key={clas.id} value={clas.id}>
                    {clas.class_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group> */}

              <Form.Group className="mb-3">
                <Form.Label>Course *</Form.Label>
                <Form.Select
                  name="course_id"
                  value={selectedNewCourse}
                  onChange={handleCourseChange}
                >
                  <option value="">Select Course</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.id}>
                      {course.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {classes.length === 0 && selectedNewCourse && (
                <p style={{ color: 'red', letterSpacing: '1px' }}>
                  The selected course has no class. Please{' '}
                  <span
                    className="blinking-link"
                    onClick={handleNavigateToCreateClass}
                  >
                    click here
                  </span>{' '}
                  to create new class.
                </p>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Class *</Form.Label>
                <Form.Select
                  name="class_id"
                  value={newAssignedTeacher.class_id}
                  onChange={handleClassChange}
                  disabled={!courseTouched || classes.length === 0}
                >
                  <option value="">Select Class</option>
                  {classes.map((clas) => (
                    <option key={clas.id} value={clas.id}>
                      {clas.class_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {studentCount !== null && studentCount !== 'No data available' && (
                <div
                  style={{
                    color: countColor,
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    letterSpacing: '1px',
                  }}
                >
                  {studentCount.current === null
                    ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                    : studentCount.current === studentCount.maximum_limit
                    ? 'There are no more seats available in this class.'
                    : `There are ${
                        studentCount.maximum_limit - studentCount.current
                      } seats left in this class.`}
                </div>
              )}

              <FormGroup className="mb-3">
                <FormLabel>Teachers</FormLabel>
                <FormSelect
                  name="teacher_id"
                  value={newAssignedTeacher.teacher_id}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Teacher</option>
                  {teachers.map((teacher) => (
                    <option key={teacher.id} value={teacher.id}>
                      {teacher.name}
                    </option>
                  ))}
                </FormSelect>
              </FormGroup>
              <Form.Group className="mb-3">
                <Form.Check
                  className="text-danger"
                  type="checkbox"
                  id="acknowledgeCheckbox"
                  label="I acknowledge and agree that this process is irreversible and cannot be undone."
                  checked={isAcknowledged}
                  onChange={(e) => setIsAcknowledged(e.target.checked)}
                />
              </Form.Group>
              <Modal.Footer>
                <Button variant="danger" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button
                  variant="success"
                  type="submit"
                  disabled={!isAcknowledged}
                >
                  Save Assign
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <EditAssignClass
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          assignData={selectedClass}
          onUpdate={fetchAssignedClasses}
        />
      </div>
    </>
  )
}

export default AssignClass
